
import Vue from "vue";
import { mapState } from "vuex";
import { download } from "@/utils";

export default Vue.extend({
  data() {
    return {};
  },
  computed: {
    ...mapState("app", {
      language: "language",
      isCN: "isCN",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      url: "url",
      oss: "oss"
    }),
    productAlt(): string {
      return this.isCN ? "AM Infinity .100" : "AM Infinity Mouse";
    }
  },
  methods: {
    onDownload() {
      download(this.oss.pdf_am_infinity_mouse);
    }
  }
});
